import { Outlet } from 'react-router-dom'
import { useState, useEffect } from 'react'
import useAuthExtranet from '../../../hooks/useAuthExtranet'
import useRefreshToken from '../../../hooks/useRefreshToken'

const PersistLoginExtranet = () => {
  const [isLoading, setIsLoading] = useState(true)
  const refresh = useRefreshToken()
  const { auth } = useAuthExtranet()
  useEffect(() => {
    let isMounted = true

    const verifyRefreshToken = async () => {
      try {
        await refresh()
      } catch (err) {
        /* empty */
      } finally {
        isMounted && setIsLoading(false)
      }
    }

    !auth?.accessToken ? verifyRefreshToken() : setIsLoading(false)

    return () => (isMounted = false)
  }, [])

  return <>{isLoading ? <p>Loading...</p> : <Outlet />}</>
}

export default PersistLoginExtranet
